import { useRef, useState } from "react";

export interface FileTransferEvent {
  type: "hello" | "chunk" | "done" | "error";
  transferId: string;
  name?: string;
  size?: number;
  reason?: string;
  progress?: number;
}

export function FileTransferPanel(props: {
  disabled: boolean;
  events: FileTransferEvent[];
  onUpload: (file: File) => Promise<void>;
}) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [busy, setBusy] = useState(false);

  return (
    <aside className="panel file-panel">
      <h2>File transfer (v1)</h2>
      <p className="muted tiny">
        Skeleton on `srd-file`: file_hello → file_chunk meta + binary → file_done.
      </p>
      <div className="row">
        <input
          ref={inputRef}
          type="file"
          disabled={props.disabled || busy}
          onChange={(e) => {
            const file = e.target.files?.[0];
            if (!file) return;
            setBusy(true);
            void props
              .onUpload(file)
              .catch(() => undefined)
              .finally(() => {
                setBusy(false);
                if (inputRef.current) inputRef.current.value = "";
              });
          }}
        />
      </div>
      <ul className="file-log">
        {props.events.length === 0 ? (
          <li className="muted">No transfers yet.</li>
        ) : (
          props.events
            .slice()
            .reverse()
            .slice(0, 12)
            .map((ev, i) => (
              <li key={`${ev.transferId}-${ev.type}-${i}`}>
                <span className="badge">{ev.type}</span>{" "}
                {ev.name ?? ev.transferId.slice(0, 8)}
                {ev.progress != null ? ` · ${Math.round(ev.progress * 100)}%` : ""}
                {ev.reason ? ` · ${ev.reason}` : ""}
              </li>
            ))
        )}
      </ul>
    </aside>
  );
}
